import type { ReactNode } from "react";
import { cn } from "../../utils/global.utils";

type Props = {
  title?: string;
  subTitle?: ReactNode;
  children?: ReactNode;
  classNames?: {
    root?: string;
    title?: string;
    subTitle?: string;
    children?: string;
  };
};

export default function ContentText({
  title,
  subTitle,
  children,
  classNames,
}: Props) {
  return (
    <div className={cn("space-y-4 mb-4", classNames?.root)}>
      {title && (
        <h3
          className={cn(
            "text-3xl font-semibold text-theme-neutral-800",
            classNames?.title
          )}
        >
          {title}
        </h3>
      )}
      {subTitle && (
        <h4
          className={cn(
            "text-xl font-medium text-theme-zinc-700",
            classNames?.subTitle
          )}
        >
          {subTitle}
        </h4>
      )}
      {children && (
        <p
          className={cn("text-base text-theme-slate-700", classNames?.children)}
        >
          {children}
        </p>
      )}
    </div>
  );
}
